<div
    class="modal-overlay"
    [class.modal-overlay--blur]="
        action === 'DeleteFile' || action === 'DeleteFiles' || action === 'ExtendFiles'
    "
    *ngIf="visible"
    (click)="onCancel()"
>
    <div
        class="modal-overlay__modal"
        [class.modal-overlay__modal--chat-action]="action === 'Rename' || action === 'Delete'"
        [class.modal-overlay__modal--uploads-delete]="
            action === 'DeleteFile' || action === 'DeleteFiles' || action === 'ExtendFiles'
        "
        role="dialog"
        aria-modal="true"
        aria-labelledby="title"
        (click)="$event.stopPropagation()"
    >
        <div class="modal-overlay__modal__header">
            <h1 class="modal-overlay__modal__title">
                <ng-container [ngSwitch]="action">
                    <span *ngSwitchCase="'DeleteFiles'" class="modal-overlay__modal__title">
                        Delete the selected file(s)
                    </span>
                    <span *ngSwitchCase="'ExtendFiles'" class="modal-overlay__modal__title">
                        Extend storage
                    </span>
                    <span *ngSwitchCase="'DeleteFile'" class="modal-overlay__modal__title">
                        Delete the selected file(s)
                    </span>
                    <span *ngSwitchCase="'Delete'" class="modal-overlay__modal__title"
                        >Delete chat
                    </span>
                    <span *ngSwitchCase="'Rename'" class="modal-overlay__modal__title"
                        >Rename chat
                    </span>
                </ng-container>
            </h1>

            <button
                *ngIf="
                    action === 'Rename' ||
                    action === 'Delete' ||
                    action === 'DeleteFile' ||
                    action === 'DeleteFiles' ||
                    action === 'ExtendFiles'
                "
                class="modal-overlay__modal__close"
                type="button"
                aria-label="Close"
                (click)="onCancel()"
            >
                <img src="/assets/icons/remove-icon.svg" alt="Close" />
            </button>
        </div>

        <div
            *ngIf="action == 'Delete'"
            class="modal-overlay__modal__body modal-overlay__modal__body--chat"
        >
            <p>Deleting this chat will permanently remove it from your chat history.</p>
        </div>

        <div *ngIf="action == 'DeleteFile'" class="modal-overlay__modal__body">
            <p>
                Recent or favorite chats that use the selected file(s) as a source will still be
                available, but the source(s) will no longer appear in them.
            </p>
        </div>
        <div *ngIf="action == 'DeleteFiles'" class="modal-overlay__modal__body">
            <p>
                Recent or favorite chats that use the selected file(s) as a source will still be
                available, but the source(s) will no longer appear in them.
            </p>
        </div>
        <div *ngIf="action == 'ExtendFiles'" class="modal-overlay__modal__body">
            <p>Do you want to extend storage for the selected file(s) for an additional 90 days?</p>
        </div>

        <div
            *ngIf="action == 'Rename'"
            class="modal-overlay__modal__body modal-overlay__modal__body--chat modal-overlay__modal__body--rename"
        >
            <input
                type="text"
                aria-label="Rename chat"
                class="modal-overlay__modal__input"
                [(ngModel)]="modelTitle"
                (ngModelChange)="onTitleChange($event)"
                (keyup.enter)="onConfirm()"
                autofocus
            />
        </div>

        <div class="modal-overlay__modal__actions">
            <button class="modal-overlay__modal__btn-cancel" (click)="onCancel()">Cancel</button>
            <button
                class="modal-overlay__modal__btn-confirm"
                [disabled]="!modelTitle?.trim()"
                (click)="onConfirm()"
            >
                {{ confirmButtonTitle }}
            </button>
        </div>
    </div>
</div>
